import { convertUTP2PanelNoStringToNumber, convertNumberToUTP2PanelNoString } from "./PanelNumberConversions";
/**
 * Function to get an incremented UTP2 PanelNo string. Panel Numbers with leading zeros are treated as negative numbers,
 * and if a a Subset (Panel Number with a trailing 'A') is provided, the return value will be incremented to the next whole number.
 * An empty string is returned if the provided Panel Number doesn't conform with the UTP2 device regular expression /^[0-9]{1,2}[A]?$/.
 * @param panelNo The UTP2 PanelNo
 * @returns An incremented UTP2 PanelNo string
 */
export function getNextPanelNo(panelNo: string) {
  const panelNoAsNumber = convertUTP2PanelNoStringToNumber(panelNo);

  if (panelNoAsNumber) {
    const incremented = Math.round(panelNoAsNumber) + 1;

    return convertNumberToUTP2PanelNoString(incremented);
  } else return "";
}
